import React, {Fragment} from 'react';
import ExternalDashboard from './Pages/ExternalDashboard';
import AppHeader from '../../Layout/AppHeader';
import AppSidebar from '../../Layout/AppSidebar';
import AppFooter from '../../Layout/AppFooter';

const ExternalDashboardWrapper = ({match}) => (
    <Fragment>
        <AppHeader/>
        <div className="app-main">
            <AppSidebar/>
            <div className="app-main__outer">
                <div>
                    <ExternalDashboard />
                </div>
                <AppFooter/>
            </div>
        </div>
    </Fragment>
);

export default ExternalDashboardWrapper;